import type { CompactSpec } from "../compact"
import { expandSpec } from "../compact"

/** Same compound diagram but authored in compact format — ~45% fewer tokens */
export const compoundCompact: CompactSpec = {
  id: "compound-compact",
  name: "Compound (Compact Format)",
  desc: "Use cases connect to vertical pipeline groups that converge to shared output",
  layout: "manual",
  preferences: {
    nodeWidth: 180,
    showLayerBands: false,
    edgeStyle: "smoothstep",
    edgeColor: "#4a6a8a",
    animateEdges: true,
  },
  layers: [
    { id: "usecase", name: "Use Case", color: "#818cf8" },
    { id: "group", name: "Pipeline", color: "#64748b" },
    { id: "step", name: "Step", color: "#6366f1" },
    { id: "output", name: "Output", color: "#10b981" },
  ],
  nodes: [
    {
      id: "uc-edu",
      label: "Education",
      icon: "📚",
      layer: "usecase",
      pos: [40, 0],
      desc: "Tutorials, explainers, how-to",
    },
    {
      id: "uc-mkt",
      label: "Marketing",
      icon: "📢",
      layer: "usecase",
      pos: [300, 0],
      desc: "Product demos, ads, brand",
    },
    {
      id: "uc-ent",
      label: "Entertainment",
      icon: "🎭",
      layer: "usecase",
      pos: [600, 0],
      desc: "Faceless channels, viral",
    },
    { id: "uc-soc", label: "Social", icon: "📱", layer: "usecase", pos: [860, 0], desc: "Shorts, Reels, TikTok" },
    { id: "youtube", label: "YouTube", icon: "📺", layer: "output", pos: [160, 650], desc: "Long-form + Shorts" },
    { id: "tiktok", label: "TikTok", icon: "📱", layer: "output", pos: [460, 650], desc: "Vertical clips" },
    { id: "instagram", label: "Instagram", icon: "📸", layer: "output", pos: [760, 650], desc: "Reels + carousel" },
  ],
  groups: [
    {
      id: "g-th",
      label: "Talking Head",
      icon: "🗣️",
      pos: [0, 130],
      size: [240, 460],
      layer: "group",
      childLayer: "step",
      chain: [
        { id: "th-script", label: "Script", icon: "✍️", desc: "Claude Sonnet" },
        { id: "th-voice", label: "Voice", icon: "🎙️", desc: "ElevenLabs" },
        { id: "th-video", label: "Video", icon: "🎬", desc: "Seedance" },
        { id: "th-edit", label: "Auto-Edit", icon: "✂️", desc: "NanoBanana" },
      ],
    },
    {
      id: "g-an",
      label: "Animation",
      icon: "🎨",
      pos: [300, 130],
      size: [240, 360],
      layer: "group",
      childLayer: "step",
      chain: [
        { id: "an-script", label: "Script", icon: "✍️", desc: "Claude Sonnet" },
        { id: "an-video", label: "Video", icon: "🎬", desc: "Veo 3" },
        { id: "an-edit", label: "Auto-Edit", icon: "✂️", desc: "NanoBanana" },
      ],
    },
    {
      id: "g-sl",
      label: "Slideshow",
      icon: "🖼️",
      pos: [600, 130],
      size: [240, 360],
      layer: "group",
      childLayer: "step",
      chain: [
        { id: "sl-script", label: "Script", icon: "✍️", desc: "Claude Sonnet" },
        { id: "sl-voice", label: "Voice", icon: "🎙️", desc: "ElevenLabs" },
        { id: "sl-edit", label: "Auto-Edit", icon: "✂️", desc: "NanoBanana" },
      ],
    },
    {
      id: "g-sh",
      label: "Shorts",
      icon: "⚡",
      pos: [900, 130],
      size: [240, 360],
      layer: "group",
      childLayer: "step",
      chain: [
        { id: "sh-script", label: "Script", icon: "✍️", desc: "Claude Sonnet" },
        { id: "sh-video", label: "Video", icon: "🎬", desc: "Runway Gen-3" },
        { id: "sh-edit", label: "Auto-Edit", icon: "✂️", desc: "NanoBanana" },
      ],
    },
  ],
  edges: [
    // Use cases → pipelines
    ["uc-edu", "g-th", { label: "primary" }],
    ["uc-edu", "g-sl", { style: "dashed" }],
    ["uc-mkt", "g-th"],
    ["uc-mkt", "g-an"],
    ["uc-ent", "g-an"],
    ["uc-ent", "g-sl"],
    ["uc-soc", "g-sh"],
    ["uc-soc", "g-th", { style: "dashed" }],
    // Pipelines → outputs
    ["th-edit", "youtube"],
    ["an-edit", "youtube"],
    ["an-edit", "tiktok"],
    ["sl-edit", "youtube"],
    ["sh-edit", "tiktok"],
    ["sh-edit", "instagram"],
    ["th-edit", "instagram", { style: "dashed" }],
  ],
}

/** Expanded to full DiagramSpec for rendering */
export const compoundCompactDiagram = expandSpec(compoundCompact)
